<gen-dynamic-form
  [popupMode]="payload.popupMode"
  [formConfig]="payload.formConfig"
  [formData]="formData"
  [formName]="payload.formId"
  [editMode]="payload.editMode"
  [overrides]="payload.overrides"
  [submitted]="submitted"
  [formVertical]="true"
  [disabled]="payload.disabled"
  (formInit)="updateFormData($event, true)"
  (formChange)="updateFormData($event, false)"
  (validateChange)="valid = $event"
  [disabledFields]="payload.disabledFields"
  [note]="payload.note"
  [globalConfigurations]="payload.globalConfigurations"
></gen-dynamic-form>
